module.exports = "/_next/static/images/4c7448c1d39723e447c97eaea50e76e8-mgm-invite-ticket-4.jpg";